import {
  createCycles,
  runDestroy,
  runMount,
  runPageOut,
  runPageIn,
} from "@/modules/_";

createCycles();
runPageIn();
runMount();

import { Marquee } from "@/modules/marquee";
import { DotsAnimation } from "@/modules/dots-animation";
import { PurposeProgress } from "@/modules/purpose-progress";
import { CoinsGravity } from "@/modules/coins-gravity";
import { LogosWheel } from "@/modules/logos-wheel";
import { GhostPosts } from "@/modules/ghost-posts";
import { CardBorder } from "@/modules/card-border";
import { TextAnimations } from "@/modules/text-animations";
import { CoinsAnimation } from "@/modules/coins-animation";
import { Counter } from "@/modules/counter";
import { Accordion } from "@/modules/accordion";
import { LiquidityProgress } from "@/modules/liquidity-progress";


const textAnimations = new TextAnimations();
textAnimations.init();
const marquee = new Marquee();
marquee.init();
const dotsAnimation = new DotsAnimation();
dotsAnimation.init();
const heroCoins = new CoinsAnimation('riveHero', 'heroSection', 0.8, "top 0%", "bottom top")
heroCoins.init()
const purposeProgress = new PurposeProgress();
purposeProgress.init();
const liquidityProgress = new LiquidityProgress();
liquidityProgress.init();
const counter = new Counter();
counter.init();
const cardBorder = new CardBorder();
cardBorder.init();
const coinsGravity = new CoinsGravity();
coinsGravity.init();
const logosWheel = new LogosWheel();
logosWheel.init();
const ghostPosts = new GhostPosts();
ghostPosts.init();
const accordion = new Accordion();
accordion.init();
const footerCoins = new CoinsAnimation('riveFooter', 'footerSection', -0.8, "top bottom", "bottom 20%")
footerCoins.init()

// Connect accordion clicks to coin jumps
window.addEventListener('accordion:toggle', (e) => {
  const customEvent = e as CustomEvent;
  coinsGravity.triggerJump(customEvent.detail.force);
});

history.scrollRestoration = "manual";
window.scrollTo(0, 0);